/**
 * One team: its name and your role, its spaces, its members and, for owners, its invite links
 * and what happened in it lately.
 * Remembered as the team to open next time at `/`.
 */
import { Show, createEffect, type JSX } from "solid-js";
import { save } from "../shared/storage";
import { usePages } from "./context";
import { InvitesList } from "./InvitesList";
import { MembersList } from "./MembersList";
import { LAST_TEAM_KEY } from "./routes";
import { SpacesGrid } from "./SpacesGrid";
import { TeamActivity } from "./TeamActivity";

/** The page of team `id`. */
export function TeamPage(props: { id: string }): JSX.Element {
  const { accounts, server } = usePages();
  const view = () => accounts.team(server, props.id);
  createEffect(() => {
    save(LAST_TEAM_KEY, props.id);
    void accounts.loadTeam(server, props.id);
  });
  return (
    <Show when={view()} fallback={<p class="muted">Loading the team…</p>}>
      {(team) => (
        <div class="team-page" id="team-page" data-team={team().id} data-role={team().role}>
          <header class="team-head">
            <h2>{team().name}</h2>
            <span class="role-pill" title="Your role in this team, and in its spaces">
              {team().role}
            </span>
          </header>
          <SpacesGrid team={team()} />
          <MembersList team={team()} />
          <Show when={team().role === "owner"}>
            <InvitesList team={team()} />
            <TeamActivity team={team()} />
          </Show>
        </div>
      )}
    </Show>
  );
}
